// extracted by mini-css-extract-plugin
export default {"text":"text__hYbpi","inContent":"inContent__Bj7PF"};